import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import type { JSX } from 'react';

interface Props {
  fullScreen?: boolean;
  label?: string;
}

export function LoadingSpinner({ fullScreen = false, label }: Props): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        minHeight: fullScreen ? '100vh' : 200,
        width: '100%',
      }}
    >
      <CircularProgress size={fullScreen ? 56 : 36} />
      {label && (
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      )}
    </Box>
  );
}
